import { Box } from "@mui/material";
import SignInForm from "../../components/auth/signin/signin";
function SignInPage() {
  return (
    <Box height={"100vh"}>
      <SignInForm />
    </Box>
  );
}

export default SignInPage;
